import Vue from 'vue'
import Plyr from 'plyr/dist/plyr.js'
export default ({ app }, inject) => {
  // Inject Plyr constructor so it can be used in components
  inject('plyr', Plyr)

  // Create a Vue directive for easy Plyr initialization
  Vue.directive('plyr', {
    inserted (el, binding) {
      const options = binding.value || {}
      const player = new Plyr(el, options)

      // Store player instance on element for cleanup
      el._plyrInstance = player
    },
    unbind (el) {
      // Cleanup player instance when element is removed
      if (el._plyrInstance) {
        el._plyrInstance.destroy()
      }
    }
  })
}
